import React from 'react';
import { connect } from 'react-redux';
import { GridItem } from '@drone-js/core';
import { ActivityListProps, mapStateToProps } from 'component/page/search/ActivityList/ActivityList.selectors';
import { restoreScrollPosition } from 'core-framework/window/scroller';
import { CardGridSize } from 'core-framework/constant/GridSize';
import ActivityCard from 'component/common/ActivityCard/ActivityCard';
import { ActivityCardProps } from 'core/type/ActivityCard.types';
import { useLocation } from 'react-router-dom';
import { getKeywordQueryParams } from 'gql/service/graph/activityService';

const ActivityList: React.FC<ActivityListProps> = (props): React.JSX.Element => {
    const location = useLocation();
    const locationSearch = location.search;
    const keyword = getKeywordQueryParams(locationSearch);
    const pageTypeId = props.config.pageConfig.pageTypeId;

    React.useEffect(() => {
        if (props.isLoading || props.forceNavigateToFirstPage || props.isCityPage) return;
        restoreScrollPosition();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            {props.activitiesList.map((activity: ActivityCardProps, index) => (
                <GridItem xl={CardGridSize.xl} lg={CardGridSize.lg} md={CardGridSize.md} sm={CardGridSize.sm} key={activity.id}>
                    <ActivityCard
                        activity={activity}
                        pageTypeId={pageTypeId}
                        isPopularActivitiesCard={false}
                        keyword={keyword}
                        index={index}
                        isSearchBoxFeatureGroup={props.isSearchBoxFeatureGroup}
                        elementName="activities-card"
                        shouldShowCityName={props.shouldShowCityNameOnCard}
                    />
                </GridItem>
            ))}
        </>
    );
};
ActivityList.displayName = 'ActivityList';

export default connect(mapStateToProps)(ActivityList);
